import { THEME_COLORS, THEME_FONTS } from './colors'

export const setThemeColorsFromURL = (theme = 'default') => {
  const colors = THEME_COLORS[theme] || THEME_COLORS.default
  const fonts = THEME_FONTS[theme] || THEME_FONTS.default
  // console.log('THEME_FONTS[theme]', THEME_FONTS)

  Object.entries(colors).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value)
  })

  return { colors, fonts }
}
